import React from 'react';
import { MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { loanOfficer } from '../../data/team';
export function LoanOfficerChip() {
  return <a href={`tel:${loanOfficer.phone}`} className="group flex items-center gap-2.5 rounded-full py-1 pl-1 pr-3 ring-1 ring-ink-200 transition-colors duration-150 hover:bg-white" data-id="element-537" data-mp="10nedfxoe3i7k">
      <img src={loanOfficer.photo} alt="" className="h-8 w-8 rounded-full object-cover" data-id="element-538" data-mp="qtfgdd36aomh" />
      <span className="hidden text-left leading-tight sm:block" data-id="element-539" data-mp="cufsw8recfrw">
        <span className="block text-[13px] font-medium text-ink-900" data-id="element-540" data-mp="gydqug4zjkjd">{loanOfficer.firstName}</span>
        <span className="block text-[11px] text-ink-500" data-id="element-541" data-mp="2yl40vwkxogo">Questions? Call me</span>
      </span>
      <PhoneIcon className="h-3.5 w-3.5 text-ink-400 sm:hidden" aria-label={`Call ${loanOfficer.firstName}`} data-id="element-542" data-mp="7vuumevpg663" />
    </a>;
}
export function LoanOfficerNote({
  message
}: {
  message: string;
}) {
  return <figure className="flex gap-4" data-id="element-543" data-mp="229mavx8jhoai">
      <img src={loanOfficer.photo} alt={loanOfficer.name} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-white" data-id="element-544" data-mp="228kwpjw88lok" />
      <div className="min-w-0" data-id="element-545" data-mp="2sxga90w6qqve">
        <blockquote className="text-[15px] leading-relaxed text-ink-700" data-id="element-546" data-mp="2sweuij485g7c">“{message}”</blockquote>
        <figcaption className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[13px] text-ink-500" data-id="element-547" data-mp="36nba99d1y2wz">
          <span className="font-medium text-ink-900" data-id="element-548" data-mp="32nja9l1q5538">{loanOfficer.name}</span>
          <span data-id="element-549" data-mp="2ewndsambplpn">{loanOfficer.title}</span>
          <span className="text-ink-400" data-id="element-550" data-mp="2ezj9dsap7yax">{loanOfficer.nmls}</span>
        </figcaption>
        <div className="mt-3 flex gap-2" data-id="element-551" data-mp="29zwyvqm98w5t">
          <a href={`tel:${loanOfficer.phone}`} className="inline-flex h-9 items-center gap-1.5 rounded-lg bg-white px-3 text-sm font-medium text-ink-700 ring-1 ring-ink-200 transition-colors duration-150 hover:bg-ink-50" data-id="element-552" data-mp="2nxv9ckxgg8g1">
            <PhoneIcon className="h-3.5 w-3.5" aria-hidden data-id="element-553" data-mp="3734e2796o8h" /> Call
          </a>
          <a href={`sms:${loanOfficer.phone}`} className="inline-flex h-9 items-center gap-1.5 rounded-lg bg-white px-3 text-sm font-medium text-ink-700 ring-1 ring-ink-200 transition-colors duration-150 hover:bg-ink-50" data-id="element-554" data-mp="3uefksf0baxnc">
            <MessageCircleIcon className="h-3.5 w-3.5" aria-hidden data-id="element-555" data-mp="2wyt18p4qsjgo" /> Text
          </a>
        </div>
      </div>
    </figure>;
}